import BigNumber from 'bignumber.js';

const STX_DECIMALS = 6;
const abbreviateNumber = (n: number) => {
  if (n < 1e3) return n.toString();
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(2) + 'K';
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(2) + 'M';
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(2) + 'B';
  if (n >= 1e12) return +(n / 1e12).toFixed(2) + 'T';

  return n.toString();
};

const microStxToStx: (unit: number | string | BigNumber) => BigNumber = (unit) => {
  let unitBigNumber: BigNumber;
  if (BigNumber.isBigNumber(unit)) {
    unitBigNumber = unit;
  } else {
    unitBigNumber =
      typeof unit === 'bigint' ? new BigNumber((unit as any).toString()) : new BigNumber(unit);
  }

  return unitBigNumber.shiftedBy(-STX_DECIMALS);
};

export const stacksValue = ({
  value,
  fixedDecimals = true,
  withTicker = true,
  abbreviate = false,
}: {
  value: number | string | BigNumber;
  fixedDecimals?: boolean;
  withTicker?: boolean;
  abbreviate?: boolean;
}) => {
  const stacks = microStxToStx(value);
  const stxAmount = stacks.toNumber();

  return `${
    abbreviate && stxAmount > 10000
      ? abbreviateNumber(stxAmount)
      : stxAmount.toLocaleString('en-US', {
          maximumFractionDigits: fixedDecimals ? STX_DECIMALS : 3,
        })
  }${withTicker ? ' STX' : ''}`;
};
